import { ROUTE_PATH as PRODUCT_PATH } from '@/features/productsPage/consts';

export const createEditProductLink = productId =>
  `${PRODUCT_PATH}/${productId}/edit`;
